import React, { FC } from 'react';

import DatePicker from '@ui/DatePicker';
import FormFieldWrapper from '../Wrapper';
import { IDatePickerFormField } from './interfaces';

const DatePickerFormField: FC<IDatePickerFormField> = ({
  name,
  label,
  help,
  ...props
}) => {
  return (
    <FormFieldWrapper
      name={name}
      label={label}
      help={help}
      render={({ ...fieldProps }) => {
        return <DatePicker {...props} {...fieldProps} />;
      }}
    />
  );
};

export default DatePickerFormField;
